/**
 * @Author proudlx
 * @Description user请求方法
 */
import request from "@/api/http/request";
import {
  POST_STUDENT_MY_COURSE,
  POST_COURSE_SCORE_ADD,
  POST_COURSE_SUGGESTION_ADD,
  POST_STUDENT_FAVORITES,
  POST_STUDENT_FAVORITES_LIST,
  POST_LEARNING_RECORD_LIST,
  POST_BASE_EDIT_STUDENT_TYPE,
  POST_CERT_BY_STUDENT,
  POST_STUDENT_SUBJECT_LIST,
  POST_STUDENT_EDIT_SUBJECT,
  POST_MOBILE_LEARNING_RECORD,
  POST_LEARNING_RECORD_HOME_LIST,
  POST_CERTIFICATEINFO_HOME_LIST,
  POST_NOTICE_NEW,
  POST_STUDENT_QUERY_SUBJECT_SAVE,
  POST_STUDENT_QUERY_SUBJECT_INFO,
  POST_BASE_SITE_INFO,
  POST_BASE_POSITION_LIST,

  //---志成添加----
  POST_COURSE_CONFIRM,
  //-----end---

} from "@/api/apiConst/user";
import { courseItemType } from "./courseCenter";

//
export interface userCourseItemType {
  /** 最后学习章节 */
  courseChapterId: string;
  /** 是否收藏 */
  isCollect: boolean;
  /** 是否点赞 */
  isPraise: boolean;
  /** 是否评分 */
  isScore: boolean;
  /** 最后播放时间 */
  videoNodeTime: number;
  /** 用户是否学习过 */
  courseUserFlag: boolean;
  /** 用户是否学习完课程 */
  isUserCourse: boolean;
  /** 用户考试成绩 */
  examScores?: number;


  //志成添加
  //是否弹窗的判断
  newCourseFlag?:boolean;
  //---end
}

export function postStudentMyStudent(data: { courseId: string }) {
  return request.post<userCourseItemType>(POST_STUDENT_MY_COURSE, data);
}
/** 课程评分 */
export function postCourseScoreAdd(data: { courseId: string; score: number }) {
  return request.post(POST_COURSE_SCORE_ADD, data);
}
/** 课程章节建议 */
export function postCourseSuggestionAdd(data: {
  courseId: string;
  chapterId: string;
  suggestions: string;
}) {
  return request.post(POST_COURSE_SUGGESTION_ADD, data);
}
/** 课程点赞收藏 */
export function postStudentFavorites(data: {
  /** 1收藏 2点赞 */
  type: 1 | 2;
  courseId: string;
}) {
  return request.post(POST_STUDENT_FAVORITES, data);
}
/** 课程点赞收藏列表 */
export function postStudentFavoritesList(data: {
  /** 1收藏 2点赞 */
  type: 1 | 2;
  limit: number;
  page: number;
}) {
  return request.post<{ records: courseItemType[]; total: number }>(
    POST_STUDENT_FAVORITES_LIST,
    data
  );
}

/** 学习记录列表 */
export interface recordCourseType {
  courseId?: string;
  /** 课程名称 */
  courseName?: string;
  /** 分类名称 */
  className?: string;
  /** 课程封面 */
  cover?: string;
  /** 学习进度 */
  completionRate: number;
  /** 业务id */
  businessId?: string;
}
export interface recordCourseListType {
  timeKey: string;
  list: recordCourseType[];
}
export function postLearnRecordList(data: { limit: number; page: number }) {
  return request.post<{
    records: recordCourseListType[];
    total: number;
    pages: number;
    current: number;
  }>(POST_LEARNING_RECORD_LIST, data);
}
//获取移动端首页学习进度
export function postMobileLearnRecordList() {
  return request.post<recordCourseType[]>(POST_MOBILE_LEARNING_RECORD);

  // return request.post(POST_MOBILE_LEARNING_RECORD);
}
// 修改学员类型
export function postBaseEditStudentType(data: { type: string }) {
  return request.post(POST_BASE_EDIT_STUDENT_TYPE, data);
}

export interface studentCertType {
  certificateImg: string;
  businessId: string;
  certificateTitle: string;
}
// 查询学员新证书列表
export function postCertByStudent() {
  return request.post<studentCertType[]>(POST_CERT_BY_STUDENT);
}

export interface SubjectItemType {
  label: string;
  businessId: string;
  agentType?:number;
}
// 主体信息查询列表
export function postStudentSubjectList(data: {
  label: string;
  agentType?: number;
}) {
  return request.post<SubjectItemType[]>(POST_STUDENT_SUBJECT_LIST, data);
}
// 主体信息保存
export function postStudentEditSubject(data: {
  subjectId: string;
  name: string;
}) {
  return request.post(POST_STUDENT_EDIT_SUBJECT, data);
}
// 首页学习进度
export function postLearnRecordHomeList() {
  return request.post<recordCourseType[]>(POST_LEARNING_RECORD_HOME_LIST);
}
export interface certificateHomeItemType {
  businessId: string;
  courseId: string;
  courseLearningStatusRef: string;
  coverImg: string;
  detailImg: string;
  entryStatusRef: string;
  introduce: string;
  title: string;
}
// 首页我的认证
export function postCertificateinfoHomeList(data: { homeType?: string }) {
  return request.post<certificateHomeItemType[]>(
    POST_CERTIFICATEINFO_HOME_LIST,
    data
  );
}

export interface noticeNewType {
  businessId: string;
  /** 消息时间 */
  createDateFmt: string;
  id: number;
  /** 消息体 */
  noticeContent: string;
  // 消息类型 1-通用课上线 2-专项课上线 3-课程完成 4-考试成绩 12预约课程
  noticeType: number;
  studentId: string;
  jumpUrl?: string;
}
// 查询新消息
export function postNoticeNew() {
  return request.post<noticeNewType | undefined>(POST_NOTICE_NEW);
}
export interface SubjectInfoType {
  duty?: string;
  email: string;
  num?: number;
  /** 0待审核 1通过 2不通过 */
  status: 0 | 1 | 2;
  statusRef: string;
  studentName?: string;
  catagory?: string;
  userType?: string;
  userTypeExp?: string;
  subjectName: string;
  dutyIds?: string;
}
// 主体审核信息
export function postStudentSubjectInfo() {
  return request.post<SubjectInfoType | undefined>(
    POST_STUDENT_QUERY_SUBJECT_INFO
  );
}
// 主体审核信息提交
export function postStudentSubjectSave(data: {
  email?: string;
  subjectId?: string;
  studentName?: string;
  duty?: string;
  subjectName?: string;
  userTypeExp?: string;
}) {
  return request.post<{ status: number }>(
    POST_STUDENT_QUERY_SUBJECT_SAVE,
    data
  );
}
// 内容编辑文案获取
export function postBaseSiteInfo(data: { type: string }) {
  return request.post<{ [props: string]: string }>(POST_BASE_SITE_INFO, data);
}
export interface positionItemType {
  businessId: string;
  position: string;
  positionFmt: string;
}
// 岗位列表
export function postBasePositionList(data?: { [props: string]: string }, config?: { headers?: { [props: string]: string } }) {
  return request.post<positionItemType[]>(POST_BASE_POSITION_LIST, data, config);
}

//----志成添加------
//新客户计划课程 继续学习
interface postCourseConfirmType {
  code: string; 
}


export function postCourseConfirm(data: { courseId: string,confirmFlag:boolean }) {
  return request.post<postCourseConfirmType>(POST_COURSE_CONFIRM, data);
}
//-----end----------


// 游客问卷调查是否填写过
export function getVisitorSurvey() {
  return request.post('/api/survey/getVisitorSurvey');
}

// 获取问卷调查模板
export function getSurveyTemplate() {
  return request.post('/api/survey/getSurveyTemplate',{type:2});
}

// 保存问卷调查结果
export function saveVisitorData(data: { surveyJson: any[] }) {
  return request.post('/api/survey/saveVisitorData', data);
}

